import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useChatSearchParams } from '../../../hooks/useChatSearchParams';
import { LocalStorageKeys, useLocalStorage } from '../../../hooks/useLocalStorage';

export const useUoUChatUI = (useIndividualAssistant: boolean) => {
  const { metaSiteId } = useParams<{ metaSiteId: string }>();
  const { shouldShowSplashForce, viewMode } = useChatSearchParams();
  const { getItem: getSplashScreenLocalStorage, setItem: setSplashScreenLocalStorage } = useLocalStorage(
    metaSiteId!,
    LocalStorageKeys.SPLASH_SCREEN,
    true,
  );

  const shouldShowSplash = !viewMode && !useIndividualAssistant && (shouldShowSplashForce || getSplashScreenLocalStorage());
  const [showSplash, setShowSplash] = useState<boolean>(shouldShowSplash);
  const [showChat, setShowChat] = useState<boolean>(!shouldShowSplash);
  const [showDisclaimer, setShowDisclaimer] = useState<boolean>(true);

  const showChatHandler = useCallback(() => {
    setShowSplash(false);
    setSplashScreenLocalStorage(false);
    setShowChat(true);
  }, [setSplashScreenLocalStorage]);

  const hideDisclaimer = useCallback(() => {
    setShowDisclaimer(false);
  }, []);

  return {
    showSplash,
    showChat,
    showChatHandler,
    showDisclaimer,
    hideDisclaimer,
  };
};
